/* eslint no-shadow: ["error", { "allow": ["state", "getters"] }] */
const state = {
    contextualMenu: null,
    navActions: [],
    modalLoader: null,
};

const getters = {
    contextualMenu: state => state.contextualMenu,
    navActions: state => state.navActions,
    modalLoader: state => state.modalLoader,
};

const actions = {
    createContextualMenu: ({ commit }, menu) => commit('SET_CONTEXTUAL_MENU', menu),
    disableContextualMenu: ({ commit }) => commit('SET_CONTEXTUAL_MENU', null),
    createNavActions: ({ commit }, buttons) => commit('SET_NAV_ACTIONS', buttons),
    removeNavActions: ({ commit }) => commit('SET_NAV_ACTIONS', []),
    showModalLoader: ({ commit }, message) => commit('SET_MODAL_LOADER', message),
    hideModalLoader: ({ commit }) => commit('SET_MODAL_LOADER', null),
};

const mutations = {
    SET_CONTEXTUAL_MENU: (state, value) => {
        state.contextualMenu = value;
    },
    SET_NAV_ACTIONS: (state, value) => {
        state.navActions = value;
    },
    SET_MODAL_LOADER: (state, value) => {
        state.modalLoader = value;
    },
};

export default {
    actions,
    getters,
    mutations,
    namespaced: true,
    state,
};
